import React from 'react'
import { Gift, Download, Mail } from 'lucide-react'

const Benefits: React.FC = () => {
  return (
    <section className="section-padding bg-white">
      <div className="container-max">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            즉시 받는 보너스
          </h2>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="bg-gradient-to-br from-primary-50 to-primary-100 rounded-2xl p-8 md:p-12 text-center">
            <div className="w-20 h-20 bg-primary-600 rounded-full flex items-center justify-center mx-auto mb-6">
              <Gift className="w-10 h-10 text-white" />
            </div>
            
            <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4">
              "실전 AI 툴 가이드"
            </h3>
            
            <p className="text-lg text-gray-700 mb-6">
              AI 에이전트를 위한 가이드
            </p>

            <div className="flex items-center justify-center space-x-2 text-primary-600 font-semibold text-lg">
              <Mail className="w-5 h-5" />
              <span>"가입 즉시 이메일로 전송"</span>
            </div>

            <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-6">
              <div className="bg-white p-6 rounded-lg shadow-sm">
                <Download className="w-8 h-8 text-primary-600 mx-auto mb-3" />
                <h4 className="font-semibold text-gray-900 mb-2">즉시 다운로드</h4>
                <p className="text-sm text-gray-600">가입 완료 즉시 이메일로 전송</p>
              </div>
              
              <div className="bg-white p-6 rounded-lg shadow-sm">
                <Gift className="w-8 h-8 text-primary-600 mx-auto mb-3" />
                <h4 className="font-semibold text-gray-900 mb-2">무료 제공</h4>
                <p className="text-sm text-gray-600">추가 비용 없이 완전 무료</p>
              </div>
              
              <div className="bg-white p-6 rounded-lg shadow-sm">
                <Mail className="w-8 h-8 text-primary-600 mx-auto mb-3" />
                <h4 className="font-semibold text-gray-900 mb-2">실용적 가이드</h4>
                <p className="text-sm text-gray-600">바로 활용 가능한 실전 정보</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Benefits
